import * as authenServiceURL from './authenServiceURL'
import useCallApi from '../../utilities/axios'
import useLoading from '../../control/loading/useLoading'
import { PermissionFuncInfo } from '../../stores/authen/authenStore'

export type LoginFormT = {
    type: string
    username: string
    password: string
    salt: string
}

export type ProfileT = {
    academicPositionID: number
    academicPositionName_en: string
    academicPositionName_th: string
    academicPositionOther: string
    email: string
    facultyID: number
    facultyName_en: string
    facultyName_th: string
    fax: string
    homePhone: string
    irb: number
    mobilePhone: string
    name_en: string
    name_th: string
    titleNameID: number
    titleNameOther: string
    titleName_en: string
    titleName_th: string
    userGroupId: number
    userGroupName_en: string
    userGroupName_th: string
    userId: number
    username: string
    image_path: string
    imgUpload_th: string | null
    imgUpload_en: string | null
    permission: Array<PermissionFuncInfo>
    isPhD: boolean
    only_name_en: string | null
    only_name_th: string | null
    isCunet: boolean | null
    titleNameOther_th: string | null
    titleNameOther_en: string | null
    academicPositionOther_th: string | null
    academicPositionOther_en: string | null
}

const useLogin = () => {
    const callApi = useCallApi()
    const loadingHook = useLoading()

    const post = async (values: LoginFormT) => {
        const { data } = await callApi.axiosPost<any>({
            url: authenServiceURL.login,
            params: { ...values, type: Number(values.type) },
        })
        return data
    }

    const getProfile = async (token: string, loginType?: 1 | 2) => {
        let urlProfile = authenServiceURL.getProfile
        if (loginType) {
            urlProfile = `${urlProfile}/${loginType}`
        }
        const { data } = await callApi.axiosGet<{ result: ProfileT }>({
            url: urlProfile,
            token: token,
        })
        return data.result
    }

    return { post, getProfile }
}

export default useLogin
